// extracted by mini-css-extract-plugin
var _1 = "NameCell_field__cJMqw";
var _2 = "NameCell_nameCell__QkxvW";
export { _1 as "field", _2 as "nameCell" }
